import dayjs from 'dayjs';

import { CalendarAppointmentEvent } from 'components/mrp/components/Calendar/Calendar.types';
import { EventResponse } from 'generated/index';

export const convertEventResponseToCalendarEvent = (
  event: EventResponse
): CalendarAppointmentEvent => ({
  id: event.id,
  calendarId: '',
  title: event.activity?.name ?? '',
  start: dayjs(event.start).toDate(),
  end: dayjs(event.end).toDate(),
  planningEvent: {
    ...event,
    employees: (event.employees ?? []).map((emp) => ({
      ...emp,
      nameInformal:
        [emp.firstName, emp.lastName].filter(Boolean).join(' ') ||
        emp.nameInformal
    }))
  }
});
